module.exports = __webpack_public_path__ + "img/AuroraBaddya.5a663d80.jpg";